const COLORS_EVEN = [
  '#6AC6B6',
  '#007EA5',
  '#C33B27',
  '#FDB915',
  '#381F5F',
  '#0A8B8B',
  '#8B5996',
];

// const COLORS_ODD = [
//   '#a593cd',
//   '#f78f48',
//   '#79287c',
//   '#0e3151',
//   '#057ebd',
//   '#7dc242',
// ];

const colors = {
  odd: COLORS_EVEN,
  even: COLORS_EVEN,
};

export default colors;
